module.exports = "<div class=\"accessDenied\">\n  <h1>Access Denied !</h1>\n  <div>You don't have access. Please Sign In with different account or contact to administrator.</div>\n  <div (click)=\"onLoginNavigate()\">Go Back to Login</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/403/access.denied.component.html
// module id = 451
// module chunks = 0